<ng-container *ngIf="currentProfile$ | async as currentProfile">
  <ng-container *ngIf="currentProfile.isLoggedIn">
    <sd-collapsible-text
      class="current-profile-title text-b1-m-900"
      [textContent]="currentProfile.fullName"
      [lineClamp]="3"
    ></sd-collapsible-text>
    <button *ngIf="currentProfile.companies.length > 0" class="current-profile-button" (click)="selectProfile()">
      <sd-icon [type]="iconTypes.SORTING2"></sd-icon>
      переключить профиль
    </button>
    @if (isMobile()) {
      <sd-loyalty-qr-card></sd-loyalty-qr-card>
    }
  </ng-container>
</ng-container>
